exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".success{background-color:#43a047;border-radius:0}.icon{font-size:20px;margin-right:5px}.iconVariant{opacity:0.9}.message{display:'flex';align-items:'center'}\n", ""]);

